export default __webpack_public_path__ + "static/media/semiskilled.1bccba7f.png";